import React from 'react';
import MapContainer from './MapContainer'
import Header from './Header'
import { FiAlignLeft } from "react-icons/fi";
function App() {
    const hStyle = {
        flex: 1,
        margin: 0,
        textAlign: 'center',
        fontWeight: 'bold',
        letterSpacing: '2px'
    }
    return (
        <div>
            <Header>
                <FiAlignLeft style={{ width: '60px', fontSize: '30px', textAlign: 'center' }} />
                <h2 style={hStyle}>LOGO</h2>
                <FiAlignLeft style={{ background: '#FFF', marginRight: '15px', borderRadius: '5px', width: '40px', color: '#d50320', fontSize: '30px', textAlign: 'center' }} />
            </Header>
            <MapContainer />
        </div>
    );
}

export default App;